// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assignPersonMachine_container__bEv48 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.assignPersonMachine_dropdown__item__AsiZq:hover {
  color: #e1a901;
}

/* Assign Users */
.assignPersonMachine_container__initials__Q1657 {
  display: flex;
  flex-direction: row;
  gap: 2px;
}

.assignPersonMachine_button_icon__C9r35 {
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
}

/* both */
.assignPersonMachine_icon_hover__XU23q {
  color: #075e5b;
  height: 0.9em !important;
}

.assignPersonMachine_icon__ym6sx {
  color: #8e8e8e;
  height: 0.9em !important;
}

/* Dropdown container styles */
.assignPersonMachine_dropdown_container__f4C0R {
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 140px;
  overflow: auto;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  z-index: 9999;
}

/* Dropdown item styles */
.assignPersonMachine_dropdown_item__KZuJx {
  padding: 8px 12px;
  text-decoration: none;
  display: block;
  cursor: pointer;
  font-size: 0.7rem;
  transition: background-color 0.3s;
  text-align: left;
}

.assignPersonMachine_item_unselected__tcRpP {
  color: rgba(0, 0, 0, 0.87);
  background-color: #fafafa;
}

/* Dropdown item when selected */
.assignPersonMachine_item_selected__1Wkz1 {
  color: white;
  background-color: #075e5b;
}

.assignPersonMachine_hovered_list__SY6g1 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.assignPersonMachine_overlay__o\\+lt8 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background: transparent;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/project_management/css/assignPersonMachine.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,aAAa;AACf;;AAEA,SAAS;AACT;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd;6EAC2E;EAC3E,kBAAkB;EAClB,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.dropdown__item:hover {\n  color: #e1a901;\n}\n\n/* Assign Users */\n.container__initials {\n  display: flex;\n  flex-direction: row;\n  gap: 2px;\n}\n\n.button_icon {\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n}\n\n/* both */\n.icon_hover {\n  color: #075e5b;\n  height: 0.9em !important;\n}\n\n.icon {\n  color: #8e8e8e;\n  height: 0.9em !important;\n}\n\n/* Dropdown container styles */\n.dropdown_container {\n  display: none;\n  position: absolute;\n  background-color: #fff;\n  min-width: 140px;\n  overflow: auto;\n  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),\n    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n  z-index: 9999;\n}\n\n/* Dropdown item styles */\n.dropdown_item {\n  padding: 8px 12px;\n  text-decoration: none;\n  display: block;\n  cursor: pointer;\n  font-size: 0.7rem;\n  transition: background-color 0.3s;\n  text-align: left;\n}\n\n.item_unselected {\n  color: rgba(0, 0, 0, 0.87);\n  background-color: #fafafa;\n}\n\n/* Dropdown item when selected */\n.item_selected {\n  color: white;\n  background-color: #075e5b;\n}\n\n.hovered_list {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 10;\n  background: transparent;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `assignPersonMachine_container__bEv48`,
	"dropdown__item": `assignPersonMachine_dropdown__item__AsiZq`,
	"container__initials": `assignPersonMachine_container__initials__Q1657`,
	"button_icon": `assignPersonMachine_button_icon__C9r35`,
	"icon_hover": `assignPersonMachine_icon_hover__XU23q`,
	"icon": `assignPersonMachine_icon__ym6sx`,
	"dropdown_container": `assignPersonMachine_dropdown_container__f4C0R`,
	"dropdown_item": `assignPersonMachine_dropdown_item__KZuJx`,
	"item_unselected": `assignPersonMachine_item_unselected__tcRpP`,
	"item_selected": `assignPersonMachine_item_selected__1Wkz1`,
	"hovered_list": `assignPersonMachine_hovered_list__SY6g1`,
	"overlay": `assignPersonMachine_overlay__o+lt8`
};
export default ___CSS_LOADER_EXPORT___;
